import { createFileRoute } from "@tanstack/react-router"
import { CompanyReviewsPage } from "@/features/companies/company-reviews-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/reviews")({ component: CompanyReviewsPage })
